:host {
    --wcs-breadcrumb-icon-color: var(--wcs-semantic-color-foreground-brand);
    --wcs-breadcrumb-icon-font-size: 0.5rem;
    --wcs-breadcrumb-gap: var(--wcs-semantic-spacing-base);
}

nav.wcs-breadcrumb-container {
    slot[name="hidden-items"] {
        display: none;
    }
    &.show-hidden-items {
        slot[name="hidden-items"] {
            display: contents;
        }
    }

    div[role="list"] {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin: 0;
        padding: 0;
        list-style: none;

        ::slotted(wcs-breadcrumb-item) {
            margin-right: var(--wcs-breadcrumb-gap);
        }

        ::slotted(wcs-breadcrumb-item:last-child) {
            margin-right: 0;
        }

        .item-not-slotted {
            display: flex;
            align-items: center;
            margin-right: var(--wcs-breadcrumb-gap);

            wcs-button[size="s"] {
                --wcs-button-min-width: 24px;
                --wcs-button-height: 20px;
                --wcs-button-border-radius: 2px;
                transform: translateY(2px);
            }

            .item-icon {
                margin-left: calc(var(--wcs-breadcrumb-gap) - 1px);
                font-family: "icons";
                font-size: var(--wcs-breadcrumb-icon-font-size);
                color: var(--wcs-breadcrumb-icon-color);
                transform: translateY(1px);
            }
        }
    }
}
